var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useRequest } from '../../../hooks/requestHook';
import { transportToWarehouse as api } from '../../../api';
import MaterialTable from '../../MaterialTable';
import { useNotify } from '../../../hooks/notificationHook';
import { useTransportToWarehouseColumns } from '../../../hooks/useColumns';
import { useTransportToWarehouse } from '../../../hooks/useTransportToWarehouse';
var ProducerTransportToWarehouseTable = function (_a) {
    var offerList = _a.offerList;
    var t = useTranslation().t;
    var notify = useNotify();
    var update = useRequest(api.update);
    var transportToWarehouseColumns = useTransportToWarehouseColumns();
    var _b = useTransportToWarehouse(offerList.id), transportToWarehouses = _b.transportToWarehouses, reload = _b.reload, loading = _b.loading;
    var columns = React.useMemo(function () {
        var col = [
            transportToWarehouseColumns.warehouseName,
            transportToWarehouseColumns.ordersCount,
            __assign(__assign({}, transportToWarehouseColumns.ordersTotalQuantity), { render: function (_a) {
                    var _b = _a.ordersTotalQuantity, ordersTotalQuantity = _b === void 0 ? 0 : _b, _c = _a.typicaStockTotalQuantity, typicaStockTotalQuantity = _c === void 0 ? 0 : _c;
                    return ordersTotalQuantity + typicaStockTotalQuantity;
                } }),
            __assign(__assign({}, transportToWarehouseColumns.ordersTotalWeight), { render: function (_a) {
                    var _b = _a.ordersTotalWeight, ordersTotalWeight = _b === void 0 ? 0 : _b, _c = _a.typicaStockTotalWeight, typicaStockTotalWeight = _c === void 0 ? 0 : _c;
                    return (Number(ordersTotalWeight) + Number(typicaStockTotalWeight)).toFixed(1);
                } }),
        ];
        if (offerList.status === 'expired') {
            col.push(transportToWarehouseColumns.exportMoistureContent, transportToWarehouseColumns.exportWaterActivity);
        }
        return col;
    }, [transportToWarehouseColumns, offerList]);
    var handleUpdate = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        id: data.id,
                        offerListId: offerList.id,
                        transport_to_warehouse: {
                            export_water_activity: data.exportWaterActivity,
                            export_moisture_content: data.exportMoistureContent,
                        },
                    };
                    return [4 /*yield*/, update(request)];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.updateSuccess')]);
                    reload();
                    return [2 /*return*/];
            }
        });
    }); }, [offerList, update, notify, t, reload]);
    return (React.createElement(MaterialTable, { title: t('pages.offerList.transportToWarehouseTable'), model: "transportToWarehouse", isLoading: loading, columns: columns, data: transportToWarehouses, editable: offerList.status === 'expired'
            ? {
                onRowUpdate: handleUpdate,
            }
            : undefined }));
};
export default ProducerTransportToWarehouseTable;
